import { Col, Row, Button } from 'antd';
import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TEstablishment from './Tables/TEstablishment';
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { useHistory } from 'react-router-dom';
import styles from 'src/components/Admin/Result/Results.module.scss';
const Establishment: React.FC = () => {
    const history = useHistory();
    return (
        <div>
            <div>
                <br />
                <div className={styles["admin-header"]}>
                    <div ><span className={styles["header"]} onClick={() => history.push("/organization")}> Organizaciones</span><span> / </span>
                        <span className={styles["header-bold"]} >Establecimientos</span>
                    </div>
                </div>
                <br />
            </div>
            <TEstablishment />

        </div>

    );
};


export default Establishment;